export default "__VITE_ASSET__BOQlZKfZ__"